import { render, staticRenderFns } from "./EditGroupTournament.vue?vue&type=template&id=621ef6e3&scoped=true"
import script from "./EditGroupTournament.vue?vue&type=script&lang=js"
export * from "./EditGroupTournament.vue?vue&type=script&lang=js"
import style0 from "./EditGroupTournament.vue?vue&type=style&index=0&id=621ef6e3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621ef6e3",
  null
  
)

export default component.exports